import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TrainingItemConstants } from '../constants/training-item-constants'
import { TreeNode } from 'primeng/api';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { TrainingItemGroupService } from '../services/training-item-group.service';
import { ITrainingItemGroupDetails } from '../models/training-item-group-details';
import { NameValue } from '../../shared/models/name-value';
import { TrainingItemPersistenceService } from '../services/training-item-persistence.service';
import { ITrainingItemGroupDetailsView } from '../models/training-item-group-details-view';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { ILinkedTrainingItemDetails } from '../models/linked-training-item-details';
import { TrainingCommonService } from '../../shared/services/training-common.service';
import { UserService } from '../../my-space/user-profile/user.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { ActivatedRoute } from '@angular/router';
import { TrainingItemDocument, TrainingItemDocumentPayload } from '../models/training-item-document-payload';

@Component({
  selector: 'app-training-item-group-library',
  templateUrl: './training-item-group-library.component.html',
  styleUrls: ['./training-item-group-library.component.scss']
})
export class TrainingItemGroupLibraryComponent implements OnInit {

  topBarTitle: string = TrainingItemConstants.Training_Item_Topbar_Title;
  isTrainingItemSliderOpen = false;
  treeData: TreeNode[] = [];
  treeSelectPlaceHolderText: string = 'Select Item';
  selectedNode: any;
  trainingItemGroupList: NameValue[] = []
  trainingItemGroupDetailsList: ITrainingItemGroupDetails[] = [];
  valueField: string = 'value';
  labelField: string = 'name';
  selectedTrainingItemGroupNumber: string | null = null;
  trainingItemGroupDetails: ITrainingItemGroupDetails | undefined;
  trainingItemGroupDetailsToEdit: ITrainingItemGroupDetailsView | undefined;
  enableEditTrainingItemGroupBtn: boolean = false;
  eqmsScopes: IEQMSScopeLookUpDetails[] = [];
  isDocumentDetailsLoaded: boolean = false;
  isCourseDetailsLoaded: boolean = false;
  loadTrainingItemGroupDetails: boolean = false;
  selectedScopeId: number = 0;
  isTrainingItemGroupDetailsLoading: boolean = false;
  accessToTrainingItemGroup: boolean = false;
  trainingItemGroupErrorMessage!:string;
  trainingItemGroupNumber ?: string;
  isLinkout ?: string
  nodes : any[] = []

  trainingItemGroupDetailsLoadingMessage: string = TrainingItemConstants.Training_Item__Group_Details_Loading;
  constructor(private eqmsScopeManagementService: EqmsScopeManagementService,
    private trainingItemGroupService: TrainingItemGroupService,
    private trainingItemPersistenceService: TrainingItemPersistenceService,
    private trainingCommonService: TrainingCommonService,
    private userService: UserService,
    private route : ActivatedRoute,
    private cd: ChangeDetectorRef) {

  }

   ngOnInit(){
    this.trainingItemGroupService.getTrainingItemGroupAuthorization().subscribe({
      next: (serviceData) => {
        this.accessToTrainingItemGroup = serviceData;
        this.loadEQMSScopeDetails();
        this.loadEQMSScope();
      },
      error: (err) => {
        this.accessToTrainingItemGroup = false;
        if(err.status === LabelConstants.Forbidden_StatusCode)
          this.trainingItemGroupErrorMessage = err.error.detail;
      }
    });

  }

  findNode(node: TreeNode<any>, value : any): TreeNode<any> | null {
    if (node.data.eQMSScopeId === value) {
      this.nodes.push(node);
      return this.nodes[0];
    }
      
    if(node.children != null){
      for (let child of node.children!) {
        let result = this.findNode(child, value);
        if (result) return result;
      }
    }
    return null; // Node not found
  }

  addTrainingItemGroup() {
    this.trainingItemPersistenceService.updateEditTrainingItemGroupSlider(false);
    this.isTrainingItemSliderOpen = !this.isTrainingItemSliderOpen;
  }
  editTrainingItemGroup() {
    this.trainingItemPersistenceService.updateEditTrainingItemGroupSlider(true);
    this.isTrainingItemSliderOpen = !this.isTrainingItemSliderOpen;
  }

  closeTrainingItemSlider(isSliderActive: boolean) {
    this.isTrainingItemSliderOpen = isSliderActive;
    setTimeout(() => {
      this.updateTrainingItemGroupToDisplay();
    }, 1000);
  }

  loadEQMSScope = () => {
    this.trainingItemGroupService.getEQMSScopeForTrainingItemGroupLibrary().subscribe((eQMSScope) => {
      this.treeData.push(this.createTreeNode(eQMSScope));
      this.setUserPrimaryScope();
    });
  }
  
  private createTreeNode(node: any): TreeNode {
    const isNodeEnabled = node.isEnable;
 
    return {
      label: node.eQMSScopeName,
      data: node,
      expanded: true,
      selectable: isNodeEnabled,
      children: node.children ? this.createChildNodes(node.children) : undefined,
      style: isNodeEnabled ? 'color: #000000' : 'color: #888'
    };
  }
  
  private createChildNodes(nodes: any[]): TreeNode[] {
    return nodes.map(childNode => this.createTreeNode(childNode));
  }
  

  loadEQMSScopeDetails = () => {
    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((response) => {
      this.eqmsScopes = response;
    })
  }
  setUserPrimaryScope = () => {
    let puid = sessionStorage['puid'] != null ? sessionStorage['puid'] : null;
    this.userService.getUserByPuid(puid).subscribe(userDetails => {
      this.selectedScopeId = userDetails.primaryeQMSScopeId;
       const isLinkoutRequest = this.route.snapshot.queryParamMap.get('isLinkout') === 'true';
       if (!isLinkoutRequest) {
         this.getTrainingItemGroups(this.selectedScopeId);
       }
       this.setDefaultScope();
       this.checkIfUserHasAccessToTrainingItemGroup()
    })
  }

  checkIfUserHasAccessToTrainingItemGroup(){
    this.isLinkout = this.route.snapshot.queryParamMap.get('isLinkout')!;
    this.trainingItemGroupNumber = this.route.snapshot.queryParamMap.get('trainingItemGroupNumber')!;
    if(this.isLinkout != undefined && this.isLinkout == 'true'){
      this.trainingItemGroupService.getTrainingItemGroupScopesForTrainingItemGroupNumber(this.trainingItemGroupNumber!).subscribe
      (
        {
          next:(trainingItemGroupDetails)=>{
        this.trainingItemGroupDetails = trainingItemGroupDetails
          var node = this.findNode(this.treeData[0], trainingItemGroupDetails.eqmsScopes[0]);
          if (node) {
            this.selectedNode = node;
            this.getTrainingItemGroups(node.data.eQMSScopeId);
            this.selectedTrainingItemGroupNumber = this.trainingItemGroupDetails?.number!;
            this.onTrainingItemGroupChange();
            this.loadTrainingItemGroupDetails = true;
          }
      },
    error:(err)=>{
      this.accessToTrainingItemGroup = false;
      if(err.status === LabelConstants.Forbidden_StatusCode)
        this.trainingItemGroupErrorMessage = err.error.detail;
      // Linkout fetch failed: fall back to loading the primary scope's TIG list
      // so the dropdown is not left empty (preserves pre-fix behavior).
      this.getTrainingItemGroups(this.selectedScopeId);
      }})
    }
  }

   setDefaultScope = () => {
    if (!!this.treeData) {
      if (this.treeData[0].data?.eQMSScopeId === this.selectedScopeId) {
        this.selectedNode = this.treeData[0];
      } else if (!!this.treeData[0].children) {
        this.checkChildNodeIsDefaultScope(this.treeData[0].children);
      }
    }
  }

  checkChildNodeIsDefaultScope = (treeData: any) => {
    treeData.forEach((item: any) => {
      if (item.data?.eQMSScopeId === this.selectedScopeId) {
        this.selectedNode = item;
        return;
      } else if (item.children !== undefined) {
        this.checkChildNodeIsDefaultScope(item.children);
      }
    });
  };
  nodeSelect = (selectedScope: any) => {
    if (selectedScope.node.data.eQMSScopeId !== this.selectedScopeId) {
      this.selectedScopeId = selectedScope.node.data.eQMSScopeId;
      this.getTrainingItemGroups(this.selectedScopeId);
    }
  }

  onTrainingItemGroupChange = () => {
    if (this.selectedTrainingItemGroupNumber != null) {
      this.isTrainingItemGroupDetailsLoading = true;
      this.enableEditTrainingItemGroupBtn = true;
      this.trainingItemGroupDetails = this.getTrainingItemGroupToEdit(this.selectedTrainingItemGroupNumber);
      this.getTrainingItemGroupDetailsForDisplay();

    } else {
      this.isDocumentDetailsLoaded = false;
      this.isCourseDetailsLoaded = false;
      this.enableEditTrainingItemGroupBtn = false;
      this.hideOrShowTrainingItemGroupDetails();
    }
  }

  private getTrainingItemGroups = (scopeId: number): void => {
    this.trainingItemGroupService.getTrainingItemGroups(scopeId).subscribe((trainingItemGroups) => {
      this.trainingItemGroupDetailsList = trainingItemGroups;
      this.prepareTrainingItemGroups();
    });
  }

  private getTrainingItemGroupToEdit = (trainingItemGroupNumber: string): ITrainingItemGroupDetails | undefined => {
    var isTrainingItemAvailable = this.trainingItemGroupDetailsList.find((item) => item.number === trainingItemGroupNumber);
    if(!!isTrainingItemAvailable){
      return this.trainingItemGroupDetailsList.find((item) => item.number === trainingItemGroupNumber);
    }
    else{
      this.trainingItemGroupDetailsList.push(this.trainingItemGroupDetails!);
      return this.trainingItemGroupDetails;
    }
    
  }
  private prepareTrainingItemGroups = () => {
    this.trainingItemGroupList = this.trainingItemGroupDetailsList.map(item => {
      return <NameValue>{
        name: item.name,
        value: item.number
      }
    });
  }  

  private getDocumentDetailsForLinkedDocuments = (): void => {
    const documents: TrainingItemDocument[] = this.trainingItemGroupDetails?.trainingItems
      ?.filter(trainingItem => trainingItem.trainingItemType === 1)
      .map(trainingItem => ({
        number: trainingItem.trainingItemNumber,
        scheduled: trainingItem.scheduled
      })) || [];

    if (documents.length > 0) {
      const payload: TrainingItemDocumentPayload = { documents: documents };
      this.trainingItemGroupService.getEffectiveOrLatestVersionOfDocumentsScheduled(payload).subscribe({
        next: (serviceData) => {
          const trainingItemsMap = new Map(
            this.trainingItemGroupDetails?.trainingItems
              ?.filter(ti => ti.trainingItemType === 1)
              .map(ti => [ti.trainingItemNumber, ti])
          );

          let linkedItems: ILinkedTrainingItemDetails[] = serviceData.map((item: any) => {
            const trainingItem = trainingItemsMap.get(item.number);
            
            return <ILinkedTrainingItemDetails>{
              title: item.title,
              number: item.number,
              version: item.version,
              trainingType: 1,
              trainingTypeName: 'Document',
              eqmsScopes: item.eqmsScopes,
              eqmsScopeNames: this.getEQMSScopeNames(item.eqmsScopes),
              scheduled: trainingItem?.scheduled || false,
              scheduledValue: trainingItem?.scheduled ?
                TrainingItemConstants.Training_Item_Scheduled_True_Value : TrainingItemConstants.Training_Item_Scheduled_False_Value
            }
          });
          const existingNumbers = new Set(this.trainingItemGroupDetailsToEdit?.linkedTrainingItems.map(i => i.number));

          linkedItems.forEach(item => {
            if (!existingNumbers.has(item.number)) {
              this.trainingItemGroupDetailsToEdit?.linkedTrainingItems.push(item);
              existingNumbers.add(item.number); // Keep set updated
            }
          });
          
          this.isDocumentDetailsLoaded = true;
          this.hideOrShowTrainingItemGroupDetails();
        },
        error: (err) => {
          console.error('Error fetching document details', err);
          this.isDocumentDetailsLoaded = true;
          this.hideOrShowTrainingItemGroupDetails();
        }
      });
    } else {
      this.isDocumentDetailsLoaded = true;
      this.hideOrShowTrainingItemGroupDetails();
    }

  }
  private getCourseDetailsForLinkedCourses = (): void => {
    let linkedCourseNumbers: string[] = [];
    this.trainingItemGroupDetails?.trainingItems
      .forEach((trainingItem) => {
        if (trainingItem.trainingItemType === 2) {
          linkedCourseNumbers.push(trainingItem.trainingItemNumber)
        }
      });
    if (linkedCourseNumbers.length > 0) {
      this.trainingCommonService.getCourseWithListOfCourseNumbers(linkedCourseNumbers).subscribe((serviceData) => {
        let linkedItems: ILinkedTrainingItemDetails[] = serviceData.map((item: any) => {
          return <ILinkedTrainingItemDetails>{
            title: item.title,
            number: item.number,
            version: null,
            trainingType: 2,
            trainingTypeName: 'Course',
            eqmsScopes: item.eqmsScopes,
            eqmsScopeNames: this.getEQMSScopeNames(item.eqmsScopes),
            scheduled: false,
            scheduledValue : TrainingItemConstants.Training_Item_Scheduled_False_Value
          }
        });        
        linkedItems.forEach(item => {
          // Check if the item with the same number already exists in linkedTrainingItems
          const exists = this.trainingItemGroupDetailsToEdit?.linkedTrainingItems.find(existingItem => existingItem.number === item.number);
          
          // Only push the item if it doesn't already exist
          if (!exists) {
            this.trainingItemGroupDetailsToEdit?.linkedTrainingItems.push(item);
          }
        });
        this.isCourseDetailsLoaded = true;
        this.hideOrShowTrainingItemGroupDetails();
      });
    } else {
      this.isCourseDetailsLoaded = true;
      this.hideOrShowTrainingItemGroupDetails();
    }
  }

  private getEQMSScopeNames = (scopeIds: number[]): string[] => {
    let scopeNames: string[] = [];
    scopeIds.forEach((scopeId) => {
      let scopeDetails = this.eqmsScopes.find((item) => item.eQMSScopeId == scopeId);
      if (!!scopeDetails) scopeNames.push(scopeDetails?.eQMSScopeName)
    })
    return scopeNames;
  }

  private hideOrShowTrainingItemGroupDetails = () => {
    if (this.isDocumentDetailsLoaded && this.isCourseDetailsLoaded
      && !!this.trainingItemGroupDetailsToEdit) {
      this.trainingItemPersistenceService.updateSelectedTrainingItemGroup(this.trainingItemGroupDetailsToEdit);
      this.loadTrainingItemGroupDetails = true;
      this.enableEditTrainingItemGroupBtn = true;
      this.isTrainingItemGroupDetailsLoading = false;
    } else {
      this.trainingItemPersistenceService.updateSelectedTrainingItemGroup(null);
      this.loadTrainingItemGroupDetails = false;
    }
  }
  private updateTrainingItemGroupToDisplay = () => {
    if (this.trainingItemPersistenceService.isEditTrainingItemGroupSlider
      && this.trainingItemPersistenceService.isTrainingItemGroupUpdated) {
      this.isTrainingItemGroupDetailsLoading = true;
      this.trainingItemGroupService.getTrainingItemGroup(this.trainingItemGroupDetails!.number).subscribe((response) => {
        this.trainingItemGroupDetails = response;
        let updatedTrainingItemGroupIndex = this.trainingItemGroupDetailsList.findIndex(item => item.number == response.number);
        this.trainingItemGroupDetailsList[updatedTrainingItemGroupIndex] = response;
        this.prepareTrainingItemGroups();
        this.updateDefaultScope();
        this.getTrainingItemGroupDetailsForDisplay();
      });
    }
  }

  private updateDefaultScope = () => {
    if (this.trainingItemGroupDetails!.eqmsScopes.indexOf(this.selectedScopeId) < 0) {
      let scopeIds: number[] = this.trainingItemGroupDetails!.eqmsScopes.sort((s1, s2) => s1 - s2);
      this.selectedScopeId = scopeIds[0];
      this.setDefaultScope();
    }
  }
  private getTrainingItemGroupDetailsForDisplay = () => {
    this.isDocumentDetailsLoaded = false;
    this.isCourseDetailsLoaded = false;
    if (!!this.trainingItemGroupDetails) {
      this.trainingItemGroupDetailsToEdit = <ITrainingItemGroupDetailsView>{
        name: this.trainingItemGroupDetails.name,
        number: this.trainingItemGroupDetails.number,
        eqmsScopes: this.trainingItemGroupDetails.eqmsScopes,
        eqmsScopesNames: this.getEQMSScopeNames(this.trainingItemGroupDetails.eqmsScopes),
        linkedTrainingItems: []
      }
      this.getDocumentDetailsForLinkedDocuments();
      this.getCourseDetailsForLinkedCourses();
    }
  }

  trainingItemGroupAccessErrorMessage() : string{
    if (!this.accessToTrainingItemGroup) {
      return this.trainingItemGroupErrorMessage;
    }
    return TrainingItemConstants.TIGs_UnableToFetchAuth_ErrorMessage;;
  }
}
